<template>
  <simple-links :menu-items="menuItems" />
</template>

<script>
import { mapGetters } from 'vuex'

import SimpleLinks from '@/components/sidebar/SimpleLinks'

export default {
  components: {
    'simple-links': SimpleLinks
  },
  computed: {
    menuItems () {
      if (this.isLoggedIn) {
        return [
          { icon: 'mdi-timer-outline', text: 'Stechuhr', to: { name: 'index' }, exact: true },
          { icon: 'mdi-calendar-clock', text: 'Wochenansicht', to: { name: 'logs' } },
          { icon: 'mdi-chart-line-variant', text: 'Auswertung', to: { name: 'evaluation' } },
          { icon: 'mdi-account', text: 'Mitarbeiter', to: { name: 'employees' }, color: 'background-color: white' },
          { icon: 'mdi-briefcase', text: 'Projekte', to: { name: 'projects' }, color: 'background-color: white' },
          { icon: 'mdi-wrench', text: 'Tätigkeiten', to: { name: 'operations' }, color: 'background-color: white' },
          { icon: 'mdi-cog', text: 'Einstellungen', to: { name: 'settings' }, color: 'background-color: white' },
        ]
      } else {
        return []
      }
    },
    ...mapGetters({
      isLoggedIn: 'isLoggedIn'
    })
  }
}
</script>
